import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'doctype',
    standalone: false
})
export class DoctypePipe implements PipeTransform {
  private readonly map: Record<string, string> = {
    driver_license: 'Driver\'s Licence',
    aadhar: 'AADHAR Card',
    pancard: 'PAN Card',
    passport: 'Passport',
    voterid: 'Voter ID',
    nic: 'National Identity Card',
    ssc: 'Social Security Card',
    tfn: 'Tax Filing Number',
    nino: 'National Insurance Number',
    nhsn: 'National Health Service Number',
       pio: 'PIO (Person of Indian Origin)',
    oci: 'OCI (Overseas Citizen of India)',
    sic: "Social Insurance Card",
    cpf: 'Cadastro de Pessoas Físicas (CPF)',
    birth_number: 'Birth Number',
    cvr_number: 'CVR Number',
    vat_number: 'VAT Registration Number',
    hetu: 'Personal Identification Number',
    hic: 'Health Insurance Card',
    nhi: 'National Health Index Number',
    tin: 'Tax Identification Number',
    pesel_number: 'PESEL Number',
    regon: 'REGON - Identification for Business',
    hun: 'Health User Number',
    ic_number: 'Civil Identification Number',
    nie: 'NIE (Foreigner Identification Number)',
    con: 'Co-Ordination Number',
    orn: 'Organisation Number',
    // Add more if needed
  };

  transform(value: string): string {
    return this.map[value] || value;
  }
}
